import Command from '@ckeditor/ckeditor5-core/src/command';
import { toArray } from '@ckeditor/ckeditor5-utils';

export default class InsertRecorderCommand extends Command {
    refresh() {
        const recorderUtils = this.editor.plugins.get('RecorderUtils');
        this.isEnabled = recorderUtils.isRecorderAllowed();
    }

    /**
     * Inserta un recorderBlock (audio o video).
     *
     * @param {Object} options
     * @param {String|Object|Array<String|Object>} options.source
     * - Puede ser un string (URL del src)
     * - o un objeto { src: "url", type: "audio"|"video" }
     * - o un array con múltiples definiciones
     */
    execute(options) {
        const sourceDefinitions = toArray(options.source);
        const selection = this.editor.model.document.selection;
        const recorderUtils = this.editor.plugins.get('RecorderUtils');
        const selectionAttributes = Object.fromEntries(selection.getAttributes());

        sourceDefinitions.forEach((sourceDefinition, index) => {
            const selectedElement = selection.getSelectedElement();

            if (typeof sourceDefinition === 'string') {
                sourceDefinition = { src: sourceDefinition, type: 'audio' };
            }

            if (!sourceDefinition.width) {
                sourceDefinition.width = 'Original';
            }

            if (index && selectedElement && recorderUtils.isRecorder(selectedElement)) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                recorderUtils.insertRecorder(
                    { ...sourceDefinition, ...selectionAttributes },
                    position,
                    'recorderBlock'
                );
            } else {
                recorderUtils.insertRecorder(
                    { ...sourceDefinition, ...selectionAttributes },
                    null,
                    'recorderBlock'
                );
            }
        });
    }
}
